import TeamForm from '@anm/components/team/TeamForm';
import TeamInfo from '@anm/components/team/TeamInfo';
import { noop } from 'lodash';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { teamSelectors } from '../../../store/modules/team';
import TeamLoader from '../TeamLoader';

import Wrapper from './Wrapper';
import useSubmit from './hooks/useSubmit';
import useTeamFetch from './hooks/useTeamFetch';
import InvitationsListSection from '../InvitationsListSection';
import { userSelectors } from '../../../store/modules/user';

export type ManageTeamProps = {};

const defaultAvatar = 'images/team/default-avatar.svg';

const ManageTeam: FC<ManageTeamProps> = () => {
  const userTeamPermissions = useSelector(userSelectors.selectTeamPermissions);

  const teamAvatar = useSelector(teamSelectors.selectTeamAvatar);
  const avatar = teamAvatar || defaultAvatar;
  const displayName = useSelector(teamSelectors.selectTeamDisplayName);
  const isUpdatePending = useSelector(teamSelectors.selectTeamUpdatePending);
  const handleSubmit = useSubmit();

  const { isPending: isFetchPending } = useTeamFetch();

  if (isFetchPending) return <TeamLoader />;

  return (
    <Wrapper>
      {userTeamPermissions?.canUpdateTeam ? (
        <TeamForm
          initialValues={{ avatar, displayName }}
          isPending={isUpdatePending}
          onSubmit={noop}
          onAutoSave={handleSubmit}
        />
      ) : (
        <TeamInfo preview={avatar} title={displayName} />
      )}
      <InvitationsListSection />
      {/* <TeamDeleteBlock /> TODO what for simplification the delete process */}
    </Wrapper>
  );
};

export default ManageTeam;
